var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-box mb-2" }, [
    _c("div", { staticClass: "d-flex p-0 col-12" }, [
      _c("div", { staticClass: "col-1 d-flex sales-info-wrapper p-0" }, [
        _c("a", { attrs: { href: "#" } }, [
          _c(
            "div",
            {
              staticClass: "sale-ref-id pointer",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.goToUser($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.sale.full_name))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-even d-flex" }, [
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.total_jobs || 0) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.total_leads || 0) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-even d-flex" }, [
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.phone_jobs || 0) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.phone_leads || 0) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-even d-flex" }, [
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.website_jobs || 0) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.sale.website_leads || 0) + "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-even d-flex" }, [
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.sale.yelp_chat_jobs || 0) + "\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.sale.yelp_chat_leads || 0) + "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-even d-flex" }, [
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.sale.no_availability_all || 0) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 sale-info-numbers" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.sale.no_availability_website || 0) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-1 d-flex" }, [
        _c("div", { staticClass: "sale-info-numbers" }, [
          _vm._v("\n        " + _vm._s(_vm.sale.mod_jobs || 0) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 d-flex" }, [
        _c("div", { staticClass: "col-4 sale-info-numbers" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.sale.conversion_total || 0) + "%\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 sale-info-numbers" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.sale.conversion_phone || 0) + "%\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 sale-info-numbers" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.sale.conversion_website || 0) +
              "%\n      "
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9ca57d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ca57d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/sales/SalesTotalsBlock.vue
// module id = null
// module chunks = 